<div class="feedback-dialog__header">
    <h1 class="mat-dialog-title">Lad os høre fra dig</h1>
    <button mat-icon-button type="button" class="feedback-dialog__close-button" color="basic" mat-dialog-close aria-label="Luk feedback dialog" tabindex="0">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>

<mat-dialog-content>
    <form class="feedback-dialog__form" [formGroup]="feedbackForm">
        <mat-form-field appearance="fill" class="feedback-dialog__form-field">
            <mat-label>Type</mat-label>
            <mat-select formControlName="type">
                @for (type of feedbackTypes; track type.value) {
                    <mat-option [value]="type.value">
                        {{ type.label }}
                    </mat-option>
                }
            </mat-select>
            @if (feedbackForm.get("type")?.hasError("required")) {
                <mat-error> Vælg en type </mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="fill" class="feedback-dialog__form-field">
            <mat-label>Område</mat-label>
            <input matInput formControlName="area" />
            <mat-hint>f.eks. Min Side eller Oversigtskort</mat-hint>
            @if (feedbackForm.get("area")?.hasError("required")) {
                <mat-error> Område er påkrævet </mat-error>
            }
        </mat-form-field>

        @if (requiresEmailInput) {
            <mat-form-field appearance="fill" class="feedback-dialog__form-field">
                <mat-label>Din e-mail</mat-label>
                <input matInput type="email" formControlName="email" autocomplete="email" />
                <mat-hint>Vi mangler din e-mail for at kunne følge op</mat-hint>
                @if (feedbackForm.get("email")?.hasError("required")) {
                    <mat-error> E-mail er påkrævet </mat-error>
                }
                @if (feedbackForm.get("email")?.hasError("email")) {
                    <mat-error> Indtast en gyldig e-mail </mat-error>
                }
            </mat-form-field>
        }

        <mat-form-field appearance="fill" class="feedback-dialog__form-field">
            <mat-label>Besked</mat-label>
            <textarea matInput formControlName="message" rows="5"></textarea>
            @if (feedbackForm.get("message")?.hasError("required")) {
                <mat-error> Besked er påkrævet </mat-error>
            }
            @if (feedbackForm.get("message")?.hasError("minlength")) {
                <mat-error> Minimum 10 tegn </mat-error>
            }
        </mat-form-field>

        <div class="feedback-dialog__screenshot-section">
            <button
                type="button"
                mat-stroked-button
                (click)="captureScreenshot()"
                [disabled]="isCapturingScreenshot || screenshotBlob"
                class="feedback-dialog__screenshot-button"
                aria-label="Tag skærmbillede"
            >
                <mat-icon svgIcon="camera"></mat-icon>
                {{ isCapturingScreenshot ? "Tager et billede..." : "Vedhæft skærmbillede" }}
            </button>
            <mat-hint align="end">Vedhæft et billede af din nuværende skærm</mat-hint>
            @if (screenshotBlob) {
                <div class="feedback-dialog__screenshot-status">
                    <span class="feedback-dialog__screenshot-ready">✓ Skærmbillede er klar</span>

                    <button type="button" mat-icon-button (click)="clearScreenshot()" class="feedback-dialog__screenshot-clear" aria-label="Fjern skærmbillede">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            }
        </div>

        <div class="feedback-dialog__data-consent">
            <div class="feedback-dialog__consent-header">
                <mat-checkbox formControlName="agreeToShare" class="feedback-dialog__consent-checkbox">
                    <span class="feedback-dialog__consent-text"> Jeg accepterer at følgende informationer bliver delt </span>
                </mat-checkbox>
                <button
                    type="button"
                    mat-icon-button
                    (click)="toggleDataList()"
                    class="feedback-dialog__data-toggle"
                    [attr.aria-expanded]="isDataListExpanded"
                    aria-label="Vis/skjul datadetaljer"
                >
                    <mat-icon [class.feedback-dialog__data-toggle--expanded]="isDataListExpanded" svgIcon="chevron-down"></mat-icon>
                </button>
            </div>
            @if (isDataListExpanded) {
                <ul class="feedback-dialog__data-list">
                    <li class="feedback-dialog__data-list-item">Feedback type og område</li>
                    <li class="feedback-dialog__data-list-item">Min besked</li>
                    <li class="feedback-dialog__data-list-item">Mit navn/brugernavn</li>
                    @if (requiresEmailInput) {
                        <li class="feedback-dialog__data-list-item">Min e-mailadresse</li>
                    }
                    <li class="feedback-dialog__data-list-item">Værks navn</li>
                    <li class="feedback-dialog__data-list-item">Min enhedstype og version</li>
                    <li class="feedback-dialog__data-list-item">Tidsstempel for henvendelse</li>
                </ul>
            }
            @if (feedbackForm.get("agreeToShare")?.hasError("required") && feedbackForm.get("agreeToShare")?.touched) {
                <div class="feedback-dialog__consent-error">Du skal acceptere datadelinger for at fortsætte</div>
            }
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    @if (submitError) {
        <div class="feedback-dialog__submit-error" role="alert">{{ submitError }}</div>
    }
    <button mat-button type="button" (click)="onClose()" aria-label="Luk feedback dialog" [disabled]="isSending">Annuller</button>
    <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="onSubmit()"
        [disabled]="!feedbackForm.valid || isSending"
        aria-label="Send feedback"
    >
        {{ isSending ? "Sender..." : "SEND" }}
    </button>
</mat-dialog-actions>
